import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import Modal from 'components/Modal'
import Button from 'components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { dissoc, propOr, values as ramdaValues } from 'ramda'
import { getCurrentParsedQuery } from 'utils/navigation'
import Input from 'components/Input'
import EditIcon from '@mui/icons-material/Edit'
import { selectCurrentTeacher } from 'modules/teachers/ducks/selectors'
import { fetchSingleTeacherDebitItemsRoutine, fetchSingleTeacherRoutine } from 'modules/teachers/ducks/actions'
import { updateTeacherSalary } from 'services/TeachersService'
import { isNotNilOrEmpty } from 'utils/ramda'
import { parseNumber } from 'utils/numbers'

const defaultValues = {
  value: 0,
  comment: ''
}

const EditSalaryModal = ({ salary }) => {
  const teacher = useSelector(selectCurrentTeacher)
  const [values, setValues] = useState(defaultValues)

  const handleValueChange = (name, value) => {
    setValues(prev => ({ ...prev, [name]: value }))
  }

  useEffect(() => {
    setValues({
      ...salary,
      value: Math.abs(parseNumber(salary.value))
    })
  }, [salary])

  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()

  const handleOpen = e => {
    e.stopPropagation()
    setOpen(true)
  }
  const handleClose = e => {
    e && e.stopPropagation()
    setOpen(false)
  }

  const operationValue = value => {
    switch (salary.type) {
      case 'absence':
      case 'additional':
        return parseNumber(value)
      default:
        return parseNumber(value) * -1
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    const difference = Math.abs(parseNumber(values.value)) - Math.abs(parseNumber(salary.value))

    const teacherPayload = {
      ...teacher,
      balance: parseNumber(propOr(0, 'balance', teacher)) + operationValue(difference)
    }

    const successCallback = () => {
      const query = getCurrentParsedQuery()
      dispatch(fetchSingleTeacherDebitItemsRoutine({ id: teacher.id, ...query }))
      dispatch(fetchSingleTeacherRoutine({ id: teacher.id }))
      handleClose()
    }

    const teacherDebitPayload = {
      ...values,
      value: operationValue(values.value),
      balanceAfter: parseNumber(salary.balanceAfter) + operationValue(difference)
    }

    updateTeacherSalary({
      values: {
        teacherPayload,
        teacherDebitPayload,
        difference: operationValue(difference)
      },
      callback: successCallback
    })
  }

  const isValid = useMemo(() => {
    const toCheck = ramdaValues(dissoc('comment', values))
    return toCheck.every(val => isNotNilOrEmpty(val)) && parseNumber(values.value) > 0
  }, [values])

  return (
    <>
      <Trigger onClick={handleOpen}>
        <StyledIcon />
      </Trigger>
      <Modal
        title='Edytuj wpłatę'
        open={open}
        onClose={handleClose}
      >
        <Input
          name='value'
          type='number'
          label='Kwota wpłaty'
          value={values.value}
          onChange={handleValueChange}
        />
        <Input
          name='comment'
          label='Komentarz'
          value={values.comment}
          onChange={handleValueChange}
        />
        <ButtonsWrapper>
          <Button onClick={handleClose} color='secondary'>Anuluj</Button>
          <Button disabled={!isValid} color='primary' onClick={handleSubmit}>Zapisz</Button>
        </ButtonsWrapper>
      </Modal>
    </>
  )
}

export default EditSalaryModal

const Trigger = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`

const StyledIcon = styled(EditIcon)`
  transition: all .3s;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary.main};
  }
`

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`
